module.exports = __webpack_public_path__ + "static/media/Twitter.a4ea593b.svg";